import request from './request'

export function listSuppliers(params) {
  return request.get('/biz/suppliers', { params })
}
export function saveSupplier(data) {
  return request.post('/biz/suppliers', data)
}
export function deleteSupplier(id) {
  return request.delete(`/biz/suppliers/${id}`)
}
export function createSupplierAccount(id, data) {
  return request.post(`/biz/suppliers/${id}/account`, data)
}
export function getSupplierAccount(id) {
  return request.get(`/biz/suppliers/${id}/account`)
}

export function listMaterials(params) {
  return request.get('/biz/materials', { params })
}
export function saveMaterial(data) {
  return request.post('/biz/materials', data)
}
export function deleteMaterial(id) {
  return request.delete(`/biz/materials/${id}`)
}
export function downloadMaterialImportTemplate() {
  return request.get('/biz/materials/import-template', { responseType: 'blob' })
}
export function exportMaterials(params) {
  return request.get('/biz/materials/export', { params, responseType: 'blob' })
}
export function importMaterials(file) {
  const fd = new FormData()
  fd.append('file', file)
  return request.post('/biz/materials/import', fd, { timeout: 120000 })
}

export function listMaterialCategories() {
  return request.get('/biz/material-categories')
}
export function treeMaterialCategories() {
  return request.get('/biz/material-categories/tree')
}
export function saveMaterialCategory(data) {
  return request.post('/biz/material-categories', data)
}
export function deleteMaterialCategory(id) {
  return request.delete(`/biz/material-categories/${id}`)
}

export function listMaterialReqTpls(params) {
  return request.get('/biz/material-req-tpls', { params })
}
export function getMaterialReqTpl(id) {
  return request.get(`/biz/material-req-tpls/${id}`)
}
export function saveMaterialReqTpl(data) {
  return request.post('/biz/material-req-tpls', data)
}
export function deleteMaterialReqTpl(id) {
  return request.delete(`/biz/material-req-tpls/${id}`)
}

export function listContracts(params) {
  return request.get('/biz/contracts', { params })
}
export function listConfirmedMaterials(supplierId, needDate) {
  return request.get('/biz/contracts/confirmed-materials', {
    params: {
      supplierId,
      needDate: needDate || undefined
    }
  })
}
export function getContract(id) {
  return request.get(`/biz/contracts/${id}`)
}
export function saveContract(data) {
  return request.post('/biz/contracts', data)
}
export function deleteContract(id) {
  return request.delete(`/biz/contracts/${id}`)
}
export function confirmContract(id) {
  return request.post(`/biz/contracts/${id}/confirm`)
}
export function unconfirmContract(id) {
  return request.post(`/biz/contracts/${id}/unconfirm`)
}
export function downloadContractImportTemplate() {
  return request.get('/biz/contracts/import-template', { responseType: 'blob' })
}
export function importContracts(file) {
  const fd = new FormData()
  fd.append('file', file)
  return request.post('/biz/contracts/import', fd, { timeout: 120000 })
}

export function listMaterialReqs(params) {
  return request.get('/biz/material-reqs', { params })
}
export function listMaterialReqLineRows(params) {
  return request.get('/biz/material-reqs/line-rows', { params })
}
export function listSupplierMaterialReqLines(params) {
  return request.get('/biz/material-reqs/supplier-lines', { params })
}
export function exportSupplierMaterialReqLines(params) {
  return request.get('/biz/material-reqs/supplier-lines/export', { params, responseType: 'blob' })
}
export function exportMaterialReqLineRows(params) {
  return request.get('/biz/material-reqs/line-rows/export', { params, responseType: 'blob' })
}
export function getMaterialReq(id) {
  return request.get(`/biz/material-reqs/${id}`)
}
export function listMaterialReqProjectLines(projectId) {
  return request.get('/biz/material-reqs/project-lines', { params: { projectId } })
}
export function listMaterialReqProjectLineRows(projectId) {
  return request.get('/biz/material-reqs/project-line-rows', { params: { projectId } })
}
export function saveMaterialReq(data) {
  return request.post('/biz/material-reqs', data)
}
export function submitMaterialReq(id) {
  return request.post(`/biz/material-reqs/${id}/submit`)
}
export function approveMaterialReq(id) {
  return request.post(`/biz/material-reqs/${id}/approve`)
}
export function unapproveMaterialReq(id) {
  return request.post(`/biz/material-reqs/${id}/unapprove`)
}
export function rejectMaterialReq(id, reason) {
  return request.post(`/biz/material-reqs/${id}/reject`, null, { params: { reason } })
}
export function previewMaterialReceive(reqId) {
  return request.get('/biz/material-receives/preview', { params: { reqId } })
}
export function listMaterialReceives(params) {
  const query = typeof params === 'object' && params != null && !Array.isArray(params)
    ? params
    : { reqId: params }
  return request.get('/biz/material-receives', { params: query })
}
export function listMaterialReceiveLines(reqId) {
  return request.get('/biz/material-receives/lines', { params: { reqId } })
}
export function listMaterialReceiveProjectLines(projectId) {
  return request.get('/biz/material-receives/project-lines', { params: { projectId } })
}
export function listMaterialReceiveProjectLineRows(projectId) {
  return request.get('/biz/material-receives/project-line-rows', { params: { projectId } })
}
export function listMaterialReceiveLineRows(params) {
  return request.get('/biz/material-receives/line-rows', { params })
}
export function exportMaterialReceiveLineRows(params) {
  return request.get('/biz/material-receives/line-rows/export', { params, responseType: 'blob' })
}
export function getMaterialReceive(id) {
  return request.get(`/biz/material-receives/${id}`)
}
/** 生成收货单：按申请明细填写本次收货数量 */
export function createMaterialReceive(data) {
  return request.post('/biz/material-receives', data)
}
export function deleteMaterialReq(id) {
  return request.delete(`/biz/material-reqs/${id}`)
}

export function listMaterialReturns(params) {
  return request.get('/biz/material-returns', { params })
}
export function listReturnableLines(params) {
  return request.get('/biz/material-returns/returnable-lines', { params })
}
export function listMaterialReturnLines(reqId) {
  return request.get('/biz/material-returns/lines', { params: { reqId } })
}
export function listMaterialReturnProjectLines(projectId) {
  return request.get('/biz/material-returns/project-lines', { params: { projectId } })
}
export function listMaterialReturnProjectLineRows(projectId) {
  return request.get('/biz/material-returns/project-line-rows', { params: { projectId } })
}
export function listMaterialReturnLineRows(params) {
  return request.get('/biz/material-returns/line-rows', { params })
}
export function exportMaterialReturnLineRows(params) {
  return request.get('/biz/material-returns/line-rows/export', { params, responseType: 'blob' })
}
export function getMaterialReturn(id) {
  return request.get(`/biz/material-returns/${id}`)
}
export function saveMaterialReturn(data) {
  return request.post('/biz/material-returns', data)
}
export function submitMaterialReturn(id) {
  return request.post(`/biz/material-returns/${id}/submit`)
}
export function approveMaterialReturn(id) {
  return request.post(`/biz/material-returns/${id}/approve`)
}
export function unapproveMaterialReturn(id) {
  return request.post(`/biz/material-returns/${id}/unapprove`)
}
export function rejectMaterialReturn(id, reason) {
  return request.post(`/biz/material-returns/${id}/reject`, null, { params: { reason } })
}
export function completeMaterialReturn(id) {
  return request.post(`/biz/material-returns/${id}/complete`)
}
export function deleteMaterialReturn(id) {
  return request.delete(`/biz/material-returns/${id}`)
}
